import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const DeleteModal = ({ isOpen, onConfirm, onCancel, message }) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Attention</ModalHeader>
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel} id="attention-no">
          No
        </Button>
        <Button color="primary" onClick={onConfirm} id="attention-yes">
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
